import { array, nullable, string, struct } from 'io-ts/Decoder';

export const Request = struct({
	values: nullable(array(string)),
});
